<template>
  <div class="onboarding-signup-step-password">
    <VeeForm @submit="onSubmit">
      <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
        <QPage padding>
          <h2 class="step-title">
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.MAIN.PASSWORD.@TITLE")) }}
          </h2>

          <Password v-model:password="form.password" :i-model="ISignup" />

          <ExtraTipbox>
            <!-- eslint-disable vue/no-v-html -->
            <span
              v-html="
                $t('ETAB.PAGES.SIGNUP.STEPS.MAIN.PASSWORD.@NOTICE', {
                  CGU: '<a href=' + '/#/account/cgu' + '> <u>CGU</u></a>',
                  conf: '<a href=' + '/#/account/confidentiality' + '> <u>Politique de Confidentialité</u></a>',
                })
              "
            />
            <!-- eslint-enable vue/no-v-html -->
          </ExtraTipbox>
        </QPage>
      </transition>

      <QFooter>
        <div>
          <QBtn color="secondary" type="submit" class="full-width btn-navigation" :label="$t('ETAB.BUTTONS.@NEXT')" no-caps />
        </div>
      </QFooter>
    </VeeForm>
  </div>
</template>

<script setup>
  import { Form as VeeForm } from "vee-validate";
  import { ACTION_SIGNUP_UPDATE, GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { useTransition } from "@core/composables";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { FIREBASE_EVENTS } from "@core/constants";
  import { onMounted, ref } from "vue";
  import { ISignup } from "@core/models";
  import { useSignup } from "@etab/composables";
  import Password from "@etab/components/onboarding/signup/Password.component.vue";

  const { transition } = useTransition();
  const { $_nextStep, $_completeCreationProcess } = useSignup();
  const signupStore = useSignupStore();

  // Data
  const form = ref({ password: "" });

  // Methods
  const goToNextStep = async function () {
    if (signupStore[GETTER_SIGNUP_GET].hasOriginInscription()) {
      await $_completeCreationProcess({ signupData: signupStore[GETTER_SIGNUP_GET] });
      await signupStore[ACTION_SIGNUP_UPDATE]({ [ISignup.password]: null });
    } else {
      $_nextStep();
    }
    TrackingManager.addEvent({
      event: FIREBASE_EVENTS.FUNNEL,
      step: "step10_password",
    });
  };

  const onSubmit = async function () {
    const signupStore = useSignupStore();
    signupStore[ACTION_SIGNUP_UPDATE]({ [ISignup.password]: form.value.password });
    goToNextStep();
  };

  onMounted(() => {
    form.value.password = signupStore[GETTER_SIGNUP_GET][ISignup.password];
  });
</script>

<style lang="scss">
  .onboarding-signup-step-password {
    .extra-tipbox {
      margin-top: 50px;
    }
  }
</style>
